import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAlfaPartner = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 370 370"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <defs>
      <path id="alfa-partner_svg__a" d="M0 0h370v370H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <rect
        fill="#EF3124"
        fillRule="nonzero"
        width={370}
        height={370}
        rx={185}
      />
      <path
        fill="#FFF"
        fillRule="nonzero"
        d="M114.28 258.75h141.44v29.39H114.28z"
      />
      <mask id="alfa-partner_svg__b" fill="#fff">
        <use xlinkHref="#alfa-partner_svg__a" />
      </mask>
      <path
        d="M210.89 94.41c-4.03-12.03-8.68-21.53-24.61-21.53s-20.87 9.46-25.12 21.53l-43.77 124.41h29.02l10.1-29.58h55.84l9.37 29.58h30.86L210.87 94.41h.02Zm-45.91 69.85 19.84-58.96h.73l18.74 58.96h-39.31Z"
        fill="#FFF"
        fillRule="nonzero"
        mask="url(#alfa-partner_svg__b)"
      />
    </g>
  </svg>
);
const Memo = memo(SvgAlfaPartner);
export default Memo;
